import React from "react"
import { Container, Row } from "reactstrap"

// Gatsby imports
import { graphql, useStaticQuery } from "gatsby"

//Import Components
import BlogBox from "./BlogBox"
import SectionTitle from "../Shared/SectionTitle"

const LatestBlogPosts = () => {
  const data = useStaticQuery(graphql`
    {
      markdownRemark(frontmatter: { contentKey: { eq: "academyPage" } }) {
        frontmatter {
          latest_blog_posts {
            heading
            sub_heading
          }
        }
      }
    }
  `)

  const { heading, sub_heading } =
    data.markdownRemark.frontmatter.latest_blog_posts

  return (
    <Container className="mt-100 mt-60">
      {/* section title */}
      <SectionTitle title={heading} desc={sub_heading} />

      <Row>
        {/* blog box */}
        <BlogBox />
      </Row>
    </Container>
  )
}

export default LatestBlogPosts
